import * as Sentry from "@sentry/vue";
import VueCookies from "vue-cookies";
import Vue from "vue";
import { ValidationError, RequestError } from "./errorHandler.service";
import { capturePostHogException } from "@/plugins/posthog-error-management";
Vue.use(VueCookies);

function resolveErrorKind(error: any): string {
  if (error instanceof ValidationError) {
    return "ValidationError";
  }
  if (error instanceof RequestError) {
    return "RequestError";
  }
  if (error?.name) {
    return String(error.name);
  }
  return "unknown";
}

interface HandleErrorParams {
  rootMethod?: string | null;
  rootPayload?: any;
  displayError?: boolean;
  error: any;
}

class CustomException {
  static async handleError(
    {
      rootMethod = null,
      rootPayload = null,
      displayError = true,
      error,
    }: HandleErrorParams,
    vueContext: any
  ): Promise<void> {
    let toClientMessage: string = "Error message default";

    if (displayError) {
      if (error instanceof ValidationError) {
        toClientMessage = error.displayedMessage;
      } else {
        toClientMessage =
          error?.response?.data?.message ??
          "Un error inesperado ha ocurrido. Contacte con el administrador.";
      }

      if (vueContext && vueContext?.$store) {
        vueContext.$store.dispatch("app/showError", {
          error: { message: toClientMessage },
        });
      }
    }

    const componentName =
      vueContext?.$options?.name ||
      'Componente no registrado (falta "name" en el componente)';
    const errorDetails = {
      method: rootMethod,
      payload: rootPayload,
      toClientMessage,
      componentName,
      props: vueContext?.$options?.propsData,
      user: Vue.$cookies?.get("user") ?? "Not identified User",
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      errorLog: {
        error,
        details:
          error instanceof ValidationError
            ? error.details
            : "No hay detalles disponibles",
      },
    };

    console.error(error, error?.details ?? null);

    Sentry.withScope((scope) => {
      scope.setExtras(errorDetails);
      Sentry.captureException(error);
    });

    if (!(error instanceof ValidationError)) {
      capturePostHogException(error, {
        root_method: rootMethod || undefined,
        component_name: componentName,
        to_client_message: toClientMessage,
        error_kind: resolveErrorKind(error),
      });
    }

    // Slack webhook integration (frontend)
    try {
      const slackWebhookUrl =
        "https://hooks.slack.com/services/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";

      const postData = {
        text: `(Frontend)Error report:\n${JSON.stringify(
          errorDetails,
          null,
          2
        )}`,
      };

      await fetch(slackWebhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });
    } catch (slackError) {
      console.warn("Failed to send error to Slack:", slackError);
    }
  }
}

export default CustomException;
